// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_ZBm","cls2":"NewsInteractionBar-cls2_vWh NewsInteractionBar-cls1_ZBm"};